import { feProcedureModalMount } from 'actions/ui.actions';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import logger from 'utils/logger.util';

const L = logger('procedureModalReducer'); // eslint-disable-line no-unused-vars

const MAP = Object.freeze({
  [feProcedureModalMount.AT.name]: (state, action) => {
    const mounted = fromAnyToBool(action?.data?.mounted);
    return state?.mounted === mounted ? state : { ...state, mounted };
  },
});

const procedureModalReducer = (state, action) => (MAP[action?.type] || alwaysSame)(state ?? {}, action ?? {});

// noinspection JSUnusedGlobalSymbols
export default procedureModalReducer;
